"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var selection_1 = require("./selection");
function selectionReducer(state, action) {
    switch (action.action) {
        case "CLEAR_SELECTION":
            return __assign({}, state, { cursor: null, activeSelection: selection_1.NoSelection.instance, pastSelection: selection_1.NoSelection.instance });
        case "CARDINAL_CELL_MOVEMENT": {
            var grid = action.grid, traverser = action.traverser, sourceCell = action.sourceCell;
            var updatedState = __assign({}, state);
            var newCell = void 0;
            switch (action.direction) {
                case "up":
                    newCell = traverser.cellAddressAbove(grid, sourceCell);
                    break;
                case "down":
                    newCell = traverser.cellAddressBelow(grid, sourceCell);
                    break;
                case "left":
                    newCell = traverser.cellAddressLeft(grid, sourceCell);
                    break;
                case "right":
                    newCell = traverser.cellAddressRight(grid, sourceCell);
                    break;
            }
            if (!newCell) {
                return state;
            }
            switch (action.movementType) {
                case "move":
                case "moveToEnd":
                    moveSelection(updatedState, { cell: newCell });
                    break;
                case "extendSelection":
                    extendSelection(updatedState, { cell: newCell });
            }
            return updatedState;
        }
        case "SELECT_CELL": {
            var updatedState = __assign({}, state);
            switch (action.selectionType) {
                case "move":
                    moveSelection(updatedState, action);
                    break;
                case "extendSelection":
                    extendSelection(updatedState, action);
                    break;
                case "toggle":
                    toggleMove(updatedState, action);
                    break;
            }
            return updatedState;
        }
    }
    return state;
}
exports.selectionReducer = selectionReducer;
function moveSelection(state, _a) {
    var cell = _a.cell;
    state.pastSelection = selection_1.NoSelection.instance;
    state.activeSelection = new selection_1.RangeSelection(cell, cell);
    state.cursor = { i: cell.i, j: cell.j };
}
function extendSelection(state, _a) {
    var cell = _a.cell;
    var currentRange = state.activeSelection;
    if (currentRange.changeEnd) {
        state.activeSelection = currentRange.changeEnd(cell);
    }
    else {
        state.activeSelection = new selection_1.RangeSelection(cell, cell);
    }
    state.cursor = { i: cell.i, j: cell.j };
}
function toggleMove(state, _a) {
    var cell = _a.cell;
    var pastComposite = state.pastSelection.addSelection
        ? state.pastSelection : null;
    if (pastComposite) {
        pastComposite = pastComposite.addSelection(state.activeSelection);
    }
    else {
        pastComposite = new selection_1.CompositeSelection([state.activeSelection], []);
    }
    var isContained = pastComposite.containsCell(cell);
    var cellRange = new selection_1.RangeSelection(cell, cell, !isContained);
    if (isContained) {
        pastComposite = pastComposite.subtractSelection(new selection_1.RangeSelection(cell, cell));
    }
    state.pastSelection = pastComposite;
    state.activeSelection = cellRange;
    state.cursor = { i: cell.i, j: cell.j };
}
